import Icon from '../components/Icon.vue'

Icon.register({
  medkit: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M96 480v-352h32v-48c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v48h32v352h-320zM192 96v32h128v-32h-128zM512 176v256c0 26.5-21.5 48-48 48h-16v-352h16c26.5 0 48 21.5 48 48zM64 480h-16c-26.5 0-48-21.5-48-48v-256c0-26.5 21.5-48 48-48h16v352zM352 272c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32z'
      }
    ]
  }
})
